import { math } from '../utils'
import gsap from 'gsap/gsap-core'

class InclusionHovers {
  constructor() {
    this.isMobile = window.innerWidth < 600

    this.bindFns()
    this.DOM = this.getDOM()
    this.shapes = this.DOM.shapes.map(this.getShapeData)
    this.images = this.DOM.images.map(this.getImageData)

    this.slider = {
      x: 0,
      center: window.innerWidth / 2,
    }

    this.mouse = {
      current: {
        x: 0,
        y: 0,
      },
      target: {
        x: 0,
        y: 0,
      },
    }

    this.isMobile ? this.initMobile() : this.initDesktop()
  }

  bindFns() {
    ;['slideCheck', 'run', 'getShapeData'].forEach(
      (fn) => (this[fn] = this[fn].bind(this))
    )
  }

  getDOM() {
    return {
      slider: document.querySelector('.inclusions__shapes'),
      shapes: Array.from(document.querySelectorAll('.inclusions__shape')),
      images: Array.from(document.querySelectorAll('.inclusions__image')),
    }
  }

  getShapeData(element) {
    const {
      left,
      right,
      top,
      bottom,
      height,
      width,
    } = element.getBoundingClientRect()

    return {
      element,
      left,
      right,
      width,
      top,
      bottom,
      height,
      hoverArea: element.querySelector('.js-hover-area'),
      hoverPercent: {
        x: 0,
        y: 0,
      },
    }
  }

  getImageData(element) {
    const { height, width } = element.getBoundingClientRect()

    return {
      element,
      height,
      width,
      active: false,
    }
  }

  initMobile() {
    this.DOM.slider.scrollY = 0
    this.activateSlide(0)

    this.DOM.slider.addEventListener('scroll', () => {
      this.slider.x = this.DOM.slider.scrollLeft
      this.shapes.forEach(this.slideCheck)
    })

    this.shapes.map((shape, index) => {
      shape.element.addEventListener('click', (e) => {
        this.deactivateSlide()
        this.activateSlide(index)
        this.DOM.slider.scrollTo({
          left: shape.left + shape.width / 2 - window.innerWidth / 2,
          behavior: 'smooth',
        })
      })
    })
  }

  initDesktop() {
    this.DOM.slider.addEventListener('mousemove', ({ clientX, clientY }) => {
      this.mouse.target.x = clientX
      this.mouse.target.y = clientY
    })

    this.shapes.forEach((shape, index) => {
      this.deactivateSlide(index)

      shape.hoverArea.addEventListener('mouseenter', () => {
        this.shapes = this.DOM.shapes.map(this.getShapeData)
        this.activateSlide(index)
      })

      shape.hoverArea.addEventListener('mouseleave', () => {
        this.deactivateSlide(index)
      })
    })

    this.run()
  }

  activateSlide(index) {
    this.activeSlide = index
    this.images[index].element.classList.add('is-active')
    this.shapes[index].element.classList.add('is-active')
  }

  deactivateSlide(index = this.activeSlide) {
    this.images[index].element.classList.remove('is-active')
    this.shapes[index].element.classList.remove('is-active')
  }

  slideCheck(slide, index) {
    if (
      this.slider.x + this.slider.center > slide.left &&
      this.slider.x + this.slider.center < slide.right
    ) {
      this.activateSlide(index)
    } else {
      this.deactivateSlide(index)
    }
  }

  run() {
    requestAnimationFrame(this.run)
    this.mouse.current.x = math.lerp(
      this.mouse.current.x,
      this.mouse.target.x,
      0.075
    )
    this.mouse.current.y = math.lerp(
      this.mouse.current.y,
      this.mouse.target.y,
      0.075
    )

    this.images.forEach((image, index) => {
      this.shapes[index].hoverPercent.x = math.normalize(
        this.mouse.current.x,
        this.shapes[index].right,
        this.shapes[index].left
      )
      this.shapes[index].hoverPercent.y = math.normalize(
        this.mouse.current.y,
        this.shapes[index].bottom,
        this.shapes[index].top
      )

      const percent = this.shapes[index].hoverPercent

      image.element.style.transform = `translate3d(${math.denormalize(
        percent.x,
        -25,
        25
      )}px, ${math.denormalize(percent.y, -25, 25)}px, 0)`
    })
  }
}

export default InclusionHovers
